import $ from 'jquery';
import {LocalCheckoutGateway, registerPaymentMethod} from '@paymentplugins/wc-stripe/checkout';


class StripeACH extends LocalCheckoutGateway {
    constructor(...params) {
        super(...params);
        this.handle_create_account_change();
    }

    initialize() {
        super.initialize();
        window.addEventListener('hashchange', this.hashchange.bind(this));
        $(document.body).on('payment_method_selected', this.payment_method_selected.bind(this));
        $(document.body).on('change', '#createaccount', this.handle_create_account_change.bind(this));
    }

    updated_checkout() {
        super.updated_checkout();
        this.handle_create_account_change();
    }

    hide_place_order() {
    }

    show_payment_button() {
        this.show_place_order();
    }

    fees_enabled() {
        return this.params.fees_enabled == "1";
    }

    payment_method_selected() {
        if (this.fees_enabled()) {
            $(document.body).trigger('update_checkout');
        }
    }
}

registerPaymentMethod(
    new StripeACH(wc_stripe_ach_connections_params, '#wc_stripe_local_payment_stripe_ach')
)